export const usesNirovision = (experienceDetails: any): boolean => {
    return (
        experienceDetails?.usesNirovision ||
        experienceDetails?.details?.dropoffUsesNirovision
    );
};
